export { default } from './AmortizationScheduleTable';
